const carouselCardUtility = (classPart: string) =>
  /^carousel-card-width-\d+$/.test(classPart);

const gaps = [
  "sectionVertical",
  "containerAplifiedBottom",
  "containerGutter",
  "small",
  "large",
  "medium",
  "mulitContainerColumnGutter",
  "singelContainerColumnGutter",
  "paddingSectionContained",
  "paddingTiny",
  "paddingExtraSmall",
  "paddingSmall",
  "paddingMedium",
  "paddingLarge",
];

const gapFromConfig = (gapType: string) => (classPart: string) => {
  const regex = new RegExp(`^${gapType}-(${gaps.join("|")})$`);
  return regex.test(classPart);
};

export const twMergeConfig = {
  extend: {
    classGroups: {
      w: [carouselCardUtility],
      "stroke-w": ["stroke-functionButton"],
      "gap-y": [gapFromConfig("gap-y")],
      "gap-x": [gapFromConfig("gap-x")],
      gap: [gapFromConfig("gap")],
      px: ["px-container"],
      pt: ["pt-sectionTop", "pt-sectionVertical"],
      pb: [
        "pb-sectionBottom",
        "pb-containerAplifiedBottom",
        "pb-sectionContained",
        "pb-sectionTop",
        "pb-sectionVertical",
      ],
    },
  },
  override: {
    classGroups: {
      "font-size": [
        "text-micro",
        "text-caption",
        "text-body",
        "text-bodyLarge",
        "text-microheading",
        "text-subheading",
        "text-heading",
        "text-subtitle",
        "text-titlePage",
        "text-titleHero",
        "text-number",
        "text-button",
        "text-navButton",
      ],
    },
  },
};
